import { InitialsAvatar } from '../../shared';

export function RecentActivities() {
  const activities = [{
    userId: '7',
    user: 'Mark Anderson',
    action: 'sent a message to All Participants',
    time: '3 weeks ago',
  }, {
    userId: '4',
    user: 'Emma Wilson',
    action: 'posted a prayer request',
    time: 'Yesterday at 3:30 PM',
  }, {
    user: 'Sarah Chen',
    action: 'uploaded a file Summer Event Planning.xlsx',
    time: 'May 12, 2025',
  }, {
    user: 'David Lee',
    action: 'joined the group',
    time: '3 weeks ago',
  }];
  return <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        Recent Activities
      </h2>
      <div className="space-y-4">
        {activities.map((activity, index) => <div key={index} className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <InitialsAvatar personId={activity.userId} name={activity.user} size={40} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-gray-900">
                <span className="font-medium">{activity.user}</span>{' '}
                {activity.action}
              </p>
              <p className="text-xs text-gray-500 mt-1">{activity.time}</p>
            </div>
          </div>)}
      </div>
    </div>;
}